import { render, staticRenderFns } from "./operator-approve.vue?vue&type=template&id=2d36c7a0&lang=pug&"
import script from "./operator-approve.vue?vue&type=script&lang=js&"
export * from "./operator-approve.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports